/* global LOCIZE_API_KEY */

import i18n from 'i18next'

import Backend from 'i18next-chained-backend';
import LocalStorageBackend from 'i18next-localstorage-backend';
import LocizeBackend from 'i18next-locize-backend';
import postProcessor from 'i18next-sprintf-postprocessor'
import LanguageDetector from 'i18next-browser-languagedetector'
import { initReactI18next } from "react-i18next";


const locale = 'et'

const isDev = process.env.NODE_ENV === 'development';
i18n
  .use(initReactI18next)
  .use(isDev ? LocizeBackend : Backend)
  .use(LanguageDetector)
  .use(postProcessor);

let locizeConfig = {
  projectId: '01d84bd4-013e-4107-8e35-553dd8110bf2',
  referenceLng: 'en'
}

if(typeof LOCIZE_API_KEY !== 'undefined' && LOCIZE_API_KEY) {
  locizeConfig.apiKey = LOCIZE_API_KEY
}

let backendOptions = {
  backends: [
    LocalStorageBackend, // primary
    LocizeBackend, // fallback
  ],
  backendOptions: [
    {
      // prefix for stored languages
      prefix: 'gfy_i18next_res_',

      // expiration
      expirationTime: 24*60*60*1000,

      // language versions
      versions: {},
    },
    locizeConfig,
  ],
};

if (isDev) {
  backendOptions = locizeConfig;
  backendOptions.allowedAddOrUpdateHosts = 'localhost:3000';
}


export const i18nOptions = {
  debug: false,
  fallbackLng: 'en',
  returnEmptyString: false,
  lng: locale, // use language variable here
  keySeparator: '##',
  nsSeparator: '#!!#', // we don't use these things
  defaultNS: 'cart',
  ns: 'cart',
  saveMissing: isDev && locizeConfig.apiKey,
  backend: backendOptions,
  react: {
    useSuspense: false,
  }
};

export const init = async (options={}) => {
  await i18n.init({...i18nOptions, ...options})
};
export const __ = i18n.t.bind(i18n);
export default i18n
